<template>
  <v-app id="cedinzorg">
    <LoadingScreen :isLoading="isLoading" />
    <main v-if="!isLoading">
      <side-nav></side-nav>
      <v-toolbar color="cedinzorg-lbue" class="no-border-shadow" dark fixed app>
        <v-toolbar-side-icon
          @click.stop="toggleDrawer"
          class="hidden-sm-and-down"
        ></v-toolbar-side-icon>
        <v-toolbar-title
          ><img
            @click.stop="$router.push({ name: 'home' })"
            src="/img/logo_white.png"
            class="logo-header-white"
            height="30"
        /></v-toolbar-title>
      </v-toolbar>
      <v-content>
        <v-container fluid>
          <v-layout>
            <router-view></router-view>
            <v-snackbar
              v-for="notification in notifications"
              :key="notification.id"
              :color="notification.type"
              top
              :timeout="5000"
              :value="true"
              multi-line
            >
              {{ notification.message }}
              <v-btn
                dark
                flat
                @click="removeNotification(notification)"
                class="no-capitalized"
                >Sluiten</v-btn
              >
            </v-snackbar>
            <v-btn
              fixed
              fab
              bottom
              right
              color="dark"
              @click.stop="toggleDrawer"
              class="hidden-md-and-up no-border-shadow hamburger-menu"
            >
              <v-icon>menu</v-icon>
            </v-btn>
          </v-layout>
        </v-container>
      </v-content>
      <v-footer color="cedinzorg-blue" class="cedinzorg-footer" app>
        <span class="white--text">&copy; {{ year }} - Cedin Zorg</span>
      </v-footer>
    </main>
  </v-app>
</template>

<script>
import SideNav from "./components/SideNav";
import LoadingScreen from "./components/LoadingScreen";
import { mapState, mapActions } from "vuex";

export default {
  name: "App",
  components: { SideNav, LoadingScreen },
  data() {
    return {
      showNotification: true,
      isLoading: false
    };
  },
  mounted() {
    if (this.$route.query.noreload === undefined) {
      console.log('loading dialog');
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 3000);
    }

  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
    ...mapState("notification", ["notifications"])
  },
  methods: {
    ...mapActions("drawer", ["toggleDrawer"]),
    ...mapActions("notification", { removeNotification: "remove" })
  }
};
</script>
